import { render, staticRenderFns } from "./RawMaterialIndex.vue?vue&type=template&id=2c61a737"
import script from "./RawMaterialIndex.vue?vue&type=script&lang=js"
export * from "./RawMaterialIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports